import type { SessionStepDto } from '../../schemas/sessionSchemas';

// Bank Account Verification step (SEBI §8) — Penny Drop / Penniless, Basic / Advance.
export function isBankStep(step: SessionStepDto) {
  return /bank/i.test(step.stepType) || /bank/i.test(step.displayName);
}

// Account number: 9–18 digits (matches the gateway RegexPatterns.AccountNumber).
export function isValidAccountNumber(value: string): boolean {
  return /^\d{9,18}$/.test(value.trim());
}

// IFSC: 4 letters, then 0, then 6 alphanumerics (gateway RegexPatterns.IfscCode).
export function isValidIfsc(value: string): boolean {
  return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value.trim().toUpperCase());
}
